import React, { forwardRef } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import { white, newBorder, textPrimary } from "../../utils/colors";

const FormControlDefault = forwardRef(
  (
    {
      type,
      isRequired,
      label,
      value,
      placeholder,
      onChange,
      onBlur,
      isTouched,
      isError,
      w,
      errorMessage,
      isDisabled,
      isLabelEnabled,
      isVat,
      mb,
      labelFontSize,
      ...inputProps
    },
    ref // Accept ref as the second argument
  ) => {
    return (
      <FormControl
        mb={mb ? mb : 4}
        isRequired={isRequired}
        isInvalid={isTouched && isError}
        w={w}
        isDisabled={isDisabled}
      >
        <FormLabel
          fontSize={labelFontSize ? labelFontSize : "sm"}
          position="relative"
          color={textPrimary}
          _disabled={{
            opacity: isLabelEnabled ? 1 : 0.5,
          }}
        >
          {label}
          {isError && isTouched && (
            <Box position="absolute" top={-1} right={0} zIndex={2}>
              <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
            </Box>
          )}
        </FormLabel>
        <Input
          type={type}
          bg={white}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          fontSize={["1rem", "0.938rem"]}
          fontWeight="500"
          color={textPrimary}
          border={`1px solid ${newBorder}`}
          borderRadius="0.75rem"
          boxShadow="none !important"
          pl={isVat ? "2.5rem" : "1rem"}
          {...inputProps}
          ref={ref}
        />
      </FormControl>
    );
  }
);

export default FormControlDefault;
